// DeleteMultimedia.jsx
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

function DeleteMultimedia(props) {
	const { multimedia, mostrar, setQueMostrar, eliminarMultimedia } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar archivo multimedia</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					Está a punto de eliminar el archivo multimedia <strong>{multimedia.descripcion}</strong>.
					Esta acción no se puede deshacer.
				</Alert>
				<div className="text-center">
					<img
						src={process.env.REACT_APP_API_URL + 'uploads/' + multimedia.url}
						alt={multimedia.descripcion}
						className="img-fluid"
					/>
				</div>
				<p>¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-tertiary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="primary" onClick={() => eliminarMultimedia(multimedia.id)}>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default DeleteMultimedia